import React from 'react';
import { Phone, Mail, MapPin, Clock, Linkedin, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-secondary-dark text-white pt-20 pb-10" data-id="element-71">
      <div className="w-full max-w-[1200px] mx-auto px-6" data-id="element-72">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-73">
          <div className="space-y-6" data-id="element-74">
            <div className="flex items-center" data-id="element-75">
              <div className="font-bold text-xl tracking-tight text-white relative" data-id="element-76">
                <span className="text-primary font-extrabold" data-id="element-77">1001</span>
                <span className="ml-1 font-light" data-id="element-78">PALETTES</span>
                <div className="absolute -bottom-1 left-0 w-10 h-0.5 bg-primary rounded-full" data-id="element-79"></div>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed text-sm" data-id="element-80">
              Courtier expert en palettes bois et plastique. Nous simplifions la
              logistique des professionnels grâce à notre réseau de +500
              partenaires en Europe.
            </p>
            <div className="flex gap-4 pt-2" data-id="element-81">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-primary hover:text-white transition-all duration-300 text-gray-400" data-id="element-82">
                <Linkedin size={20} data-id="element-83" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-primary hover:text-white transition-all duration-300 text-gray-400" data-id="element-84">
                <Facebook size={20} data-id="element-85" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-primary hover:text-white transition-all duration-300 text-gray-400" data-id="element-86">
                <Instagram size={20} data-id="element-87" />
              </a>
            </div>
          </div>

          <div data-id="element-88">
            <h3 className="text-lg font-bold mb-6 text-white" data-id="element-89">Navigation</h3>
            <ul className="space-y-3 text-sm" data-id="element-90">
              {['Accueil', 'Notre gamme', 'Nos services', "Zones d'intervention", 'RSE', 'Contact'].map(item => <li key={item} data-id="element-91">
                  <a href={`#${item.toLowerCase().replace(/ /g, '-').replace(/'/g, '')}`} className="text-gray-400 hover:text-primary hover:pl-2 transition-all duration-300 block" data-id="element-92">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-93">
            <h3 className="text-lg font-bold mb-6 text-white" data-id="element-94">Légal</h3>
            <ul className="space-y-3 text-sm" data-id="element-95">
              {['Mentions légales', 'Politique de confidentialité', 'CGV / CGU', 'Gestion des cookies'].map(item => <li key={item} data-id="element-96">
                  <a href="#" className="text-gray-400 hover:text-primary hover:pl-2 transition-all duration-300 block" data-id="element-97">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-98">
            <h3 className="text-lg font-bold mb-6 text-white" data-id="element-99">
              Nous contacter
            </h3>
            <ul className="space-y-4 text-sm" data-id="element-100">
              <li className="flex items-start text-gray-400 group" data-id="element-101">
                <Phone size={18} className="text-primary mr-3 mt-0.5 group-hover:text-white transition-colors" data-id="element-102" />
                <span className="group-hover:text-white transition-colors" data-id="element-103">
                  09 70 70 71 18
                </span>
              </li>
              <li className="flex items-start text-gray-400 group" data-id="element-104">
                <Mail size={18} className="text-primary mr-3 mt-0.5 group-hover:text-white transition-colors" data-id="element-105" />
                <span className="group-hover:text-white transition-colors" data-id="element-106">
                  contact@1001palettes.com
                </span>
              </li>
              <li className="flex items-start text-gray-400 group" data-id="element-107">
                <MapPin size={18} className="text-primary mr-3 mt-0.5 group-hover:text-white transition-colors" data-id="element-108" />
                <span className="group-hover:text-white transition-colors" data-id="element-109">
                  3 rue des Abattoirs,
                  <br data-id="element-110" />
                  38120 Saint-Egrève
                </span>
              </li>
              <li className="flex items-start text-gray-400 group" data-id="element-111">
                <Clock size={18} className="text-primary mr-3 mt-0.5 group-hover:text-white transition-colors" data-id="element-112" />
                <span className="group-hover:text-white transition-colors" data-id="element-113">
                  Lun-Ven: 8h00 - 19h00
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500" data-id="element-114">
          <p data-id="element-115">&copy; {currentYear} 1001 Palettes. Tous droits réservés.</p>
          <p data-id="element-116">Designed with precision for logistics professionals.</p>
        </div>
      </div>
    </footer>;
}